import axios from "axios";
import actions from "./actions";

import { DataService } from "../../config/data/dataService";
const {
  getAboutInfoDataBegin,
  getAboutInfoDataSuccess,
  getAboutInfoDataErr,
  getPPTInfoDetailsDataBegin,
  getPPTInfoDetailsDataSuccess,
  getPPTInfoDetailsDataErr,
  getPPTInfoDetailsDataReset,
  getPPTInfoListDataBegin,
  getPPTInfoListDataSuccess,
  getPPTInfoListDataErr,
  getPPTInfoListDataReset,
  submitPPTInfomationDataBegin,
  submitPPTInfomationDataSuccess,
  submitPPTInfomationDataErr,
  submitPPTInfomationDataReset,
  getHistoryDetailsBegin,
  getHistoryDetailsSuccess,
  getHistoryDetailsErr,
  getHistoryViewDetailsBegin,
  getHistoryViewDetailsSuccess,
  getHistoryViewDetailsErr,
  getFBOHistoryDetailsBegin,
  getFBOHistoryDetailsSuccess,
  getFBOHistoryDetailsErr,
  getFBOHistoryViewDetailsBegin,
  getFBOHistoryViewDetailsSuccess,
  getFBOHistoryViewDetailsErr,
  getExchangeDetailsBegin,
  getExchangeDetailsSuccess,
  getExchangeDetailsErr,
  getExchangeDetailsReset,
  postStartTokenBegin,
  postStartTokenSuccess,
  postStartTokenErr,
  postStartTokenReset,
  submitMissingPPTBegin,
  submitMissingPPTSuccess,
  submitMissingPPTErr,
  submitMissingPPTReset,
  postExchnagePriceBegin,
  postExchnagePriceSuccess,
  postExchnagePriceErr,
  postExchnagePriceReset,
} = actions;

// Store Dashboard Data
export const getAboutInformationData = () => {
  return async (dispatch) => {
    try {
      dispatch(getAboutInfoDataBegin());
      const response = await DataService.get("/getAboutInformation");
      if (response.status === 200 && response.data.status === true) {
        dispatch(getAboutInfoDataSuccess(response.data.data));
      } else {
        dispatch(getAboutInfoDataErr());
      }
    } catch (err) {
      dispatch(getAboutInfoDataErr(err));
    }
  };
};

// Get PPT List Data
export const getPPTinformationListData = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getPPTInfoListDataBegin());
      const response = await DataService.post("/getPPTInformationList", data);
      console.log(response);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getPPTInfoListDataSuccess(response.data.data));
      } else {
        dispatch(getPPTInfoListDataErr());
      }
    } catch (err) {
      dispatch(getPPTInfoListDataErr(err));
    }
  };
};

// Reset PPT List Data
export const getPPTinformationListReset = () => {
  return async (dispatch) => {
    dispatch(getPPTInfoListDataReset());
  };
};

// Get PPT View Details
export const getPPTinformationDetails = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getPPTInfoDetailsDataBegin());
      const response = await DataService.post(
        "/getPPTInformationDetails",
        data
      );
      if (response.status === 200 && response.data.status === true) {
        dispatch(getPPTInfoDetailsDataSuccess(response.data.data));
      } else {
        dispatch(getPPTInfoDetailsDataErr());
      }
    } catch (err) {
      dispatch(getPPTInfoDetailsDataErr(err));
    }
  };
};

// Reset PPT View Details
export const getPPTinformationDetailsReset = () => {
  return async (dispatch) => {
    dispatch(getPPTInfoDetailsDataReset());
  };
};

// Submit PPT Info
export const submitPPTInfomation = (data) => {
  return async (dispatch) => {
    try {
      dispatch(submitPPTInfomationDataBegin());

      // Create FormData from JS object
      const formData = new FormData();

      // Append scalar values
      formData.append("notes", data.notes || "");
      formData.append("interest", data.interest || "");
      formData.append("reason_walkout", data.reason_walkout || "");
      formData.append("reason_walkout_notes", data.reason_walkout_notes || "");
      // formData.append('billing',data.billing  || '');
      // formData.append('call_rating',data.call_rating  || '');
      // formData.append('price_expection',data.price_expection  || '');
      formData.append("customer_name", data.customer_name || "");
      formData.append("customer_mobile", data.customer_mobile || "");
      formData.append("endTime", data.endTime || "");
      formData.append("startTime", data.startTime || "");
      formData.append("token", data.token || "");
      formData.append("employee_id", data.employee_id || "");
      formData.append("note_to_customer", data.note_to_customer || "");
      formData.append("tp_dp_check", data.tp_dp_check || "");
      formData.append("about_tango_eye_id", data.about_tango_eye_id || "");
      formData.append(
        "product_viewed",
        JSON.stringify(data.product_viewed || [])
      );
      formData.append("model_viewed", JSON.stringify(data.model_viewed || []));
      formData.append(
        "old_model_viewed",
        JSON.stringify(data.old_model_viewed || [])
      );
      formData.append(
        "other_details",
        typeof data.other_details === "string"
          ? data.other_details
          : JSON.stringify(data.other_details || {})
      );

      // Debug log
      for (let pair of formData.entries()) {
        console.log(`${pair[0]}:`, pair[1]);
      }

      // Send formData
      const response = await axios.post("/api/submitPPTInfomation", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200 && response.data.status === true) {
        dispatch(submitPPTInfomationDataSuccess(response.data.data));
      } else {
        dispatch(submitPPTInfomationDataErr());
      }
    } catch (err) {
      console.error("submitPPTInfomation error:", err);
      dispatch(submitPPTInfomationDataErr(err));
    }
  };
};

// Reset Submit PPT View Details
export const submitPPTInfomationReset = () => {
  return async (dispatch) => {
    dispatch(submitPPTInfomationDataReset());
  };
};

export const getExchangeDetails = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getExchangeDetailsBegin());
      const response = await DataService.post("/getAboutExchangeDetails", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getExchangeDetailsSuccess(response.data));
      } else {
        dispatch(getExchangeDetailsErr(response.data));
      }
    } catch (error) {
      dispatch(getExchangeDetailsErr(error));
    }
  };
};

export const getExchangeDetailsDataReset = () => {
  return async (dispatch) => {
    dispatch(getExchangeDetailsReset());
  };
};

export const submitMissingPPT = (data) => {
  return async (dispatch) => {
    try {
      dispatch(submitMissingPPTBegin());
      const response = await DataService.post("/submitMissingPPT", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(submitMissingPPTSuccess(response.data));
      } else {
        dispatch(submitMissingPPTErr(response.data));
      }
    } catch (error) {
      dispatch(submitMissingPPTErr(error));
    }
  };
};

export const submitMissingPPTDataReset = () => {
  return async (dispatch) => {
    dispatch(submitMissingPPTReset());
  };
};

export const getHistoryDetails = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getHistoryDetailsBegin());
      const response = await DataService.post("/getAboutHistoryDetails", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getHistoryDetailsSuccess(response.data));
      } else {
        dispatch(getHistoryDetailsErr(response.data));
      }
    } catch (error) {
      dispatch(getHistoryDetailsErr(error));
    }
  };
};

export const getHistoryViewDetails = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getHistoryViewDetailsBegin());
      const response = await DataService.post("/getHistoryViewDetails", data);
      if (response.status === 200 && response.data.status) {
        dispatch(getHistoryViewDetailsSuccess(response.data.data));
      } else {
        dispatch(getHistoryViewDetailsErr(response.data));
      }
    } catch (error) {
      dispatch(getHistoryViewDetailsErr(error));
    }
  };
};

export const getFBOHistoryDetails = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getFBOHistoryDetailsBegin());
      const response = await DataService.post(
        "/getAboutFboHistoryDetails",
        data
      );
      if (response.status === 200 && response.data.status === true) {
        dispatch(getFBOHistoryDetailsSuccess(response.data));
      } else {
        dispatch(getFBOHistoryDetailsErr(response.data));
      }
    } catch (error) {
      dispatch(getFBOHistoryDetailsErr(error));
    }
  };
};

export const getFBOHistoryViewDetails = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getFBOHistoryViewDetailsBegin());
      const response = await DataService.post(
        "/getFBOHistoryViewDetails",
        data
      );
      if (response.status === 200 && response.data.status) {
        dispatch(getFBOHistoryViewDetailsSuccess(response.data.data));
      } else {
        dispatch(getFBOHistoryViewDetailsErr(response.data));
      }
    } catch (error) {
      dispatch(getFBOHistoryViewDetailsErr(error));
    }
  };
};

export const postStartToken = (data) => {
  return async (dispatch) => {
    try {
      dispatch(postStartTokenBegin());
      const response = await DataService.post("/postStartToken", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(postStartTokenSuccess(response.data));
      } else {
        dispatch(postStartTokenErr(response.data));
      }
    } catch (error) {
      dispatch(postStartTokenErr(error));
    }
  };
};

export const postStartTokenDataReset = () => {
  return async (dispatch) => {
    dispatch(postStartTokenReset());
  };
};

export const postExchnagePrice = (data) => {
  return async (dispatch) => {
    try {
      dispatch(postExchnagePriceBegin());
      const response = await DataService.post(
        "/postExchangeDetails",
        data
      );
      if (response.status === 200 && response.data.status === true) {
        dispatch(postExchnagePriceSuccess(response.data.data));
      } else {
        dispatch(postExchnagePriceErr(response.data));
      }
    } catch (err) {
      dispatch(postExchnagePriceErr(err));
    }
  };
};

export const postExchnagePriceDataReset = () => {
  return async (dispatch) => {
    dispatch(postExchnagePriceReset());
  };
};
